import { createIcon } from "@chakra-ui/icons"

export default createIcon({
  displayName: "Chevron",
  viewBox: "0 0 24 12",
  path: <path d="M0 0L12 6L24 0L12 12L0 0Z" fill="currentColor" />,
})
